import { render, staticRenderFns } from "./DiscussionCommentAdd.vue?vue&type=template&id=49215352&"
import script from "./DiscussionCommentAdd.vue?vue&type=script&lang=js&"
export * from "./DiscussionCommentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports